import React from 'react';
import { auth, db } from '../../firebase/index';
import { getRandomInt } from '../../function/common';
import { fetchCounterAction, fetchProverbAction } from './actions';

const proverbRef = db.collection('todayProverb');
const userRef = db.collection('users');

export const fetchProverb = () => {
    return async (dispatch) => {
        // Firestoreに格納されているproverbの長さをfirebaseから取得しようとしたが
        // アクセス数を増やすと課金対象になる可能性があるため、ここで長さを定義する
        const PROVERB_COUNT = 10
        // 'proverb' + getRandomInt(1, proverbCount)の意義
        // FirestoreのtodayProverbコレクションの中に
        // proverb1, proverb2, proverb3...と格納されているため
        // それらをランダムに取得するためのコード
        let query = proverbRef.doc('proverb' + getRandomInt(1, PROVERB_COUNT));
        query.get()
            .then((proverb) => {
                dispatch(fetchProverbAction(proverb.data()))
            })
            
    }
}

export const fetchCounter = () => {
    return async (dispatch) => {
        return auth.onAuthStateChanged((user) => {
            if (user) {
                var uid = user.uid;
                userRef.doc(uid).get()
                    .then((doc) => {
                        if (doc.exists) {
                            dispatch(fetchCounterAction(doc.data().counter))
                        }
                        else {
                            // TODO:throw error, if doc not exist
                        }
                    })
                // ...
            } else {
                // User is signed out
                // ...
            }
          });
    }
}